import { render, staticRenderFns } from "./OpenGraphCard.vue?vue&type=template&id=b5bc92e4&"
import script from "./OpenGraphCard.vue?vue&type=script&lang=js&"
export * from "./OpenGraphCard.vue?vue&type=script&lang=js&"
import style0 from "./OpenGraphCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports